// this exists so we do not have to duplicate initialization logic between storybook, jest, and our main app
import Vue from 'vue';
import Buefy from 'buefy';
import VueClipboard from 'vue-clipboard2';
import { lsFilters } from 'ls-vue-common';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

Vue.use(Buefy);
Vue.use(VueClipboard);

Vue.filter('currency', lsFilters.templateFilters.currency);
Vue.filter('date', lsFilters.templateFilters.date);
Vue.filter('formattedPhone', lsFilters.templateFilters.formattedPhone);
Vue.filter('frequency', lsFilters.templateFilters.frequency);
Vue.filter('fullName', lsFilters.templateFilters.fullName);
Vue.filter('titleCase', lsFilters.templateFilters.titleCase);

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
